import { render, staticRenderFns } from "./icon-chevron-left.vue?vue&type=template&id=cc71755c&"
import script from "./icon-chevron-left.vue?vue&type=script&lang=js&"
export * from "./icon-chevron-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports